// extracted by mini-css-extract-plugin
export var container = "header-module--container--hcrqD";
export var unauthenticated = "header-module--unauthenticated--NTaAv";
export var authenticated = "header-module--authenticated--2FtUY";
export var login = "header-module--login--2yyfm";
export var logo = "header-module--logo--3tWQ2";
export var menuButton = "header-module--menu-button--2uwMP";
export var sos = "header-module--sos--1fmLv";
export var goBack = "header-module--go-back--2P_oK";
export var log = "header-module--log--qGK3V";
export var menu = "header-module--menu--1LBBy";
export var active = "header-module--active--8yorc";
export var backArrowPresent = "header-module--back-arrow-present--349Cm";
export var menuButtonSpecial = "header-module--menu-button-special--4MXx-";